import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import { projects } from "@/mocks/projects";

export default function FeaturedProject() {
  const project = projects.find((p) => p.highlighted) ?? projects[0];

  return (
    <section className="px-4 md:px-8 lg:px-12 py-20 md:py-28">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        <Reveal className="flex flex-col items-center gap-4 text-center">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary-600">
            Proyecto destacado
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-900">
            Carmen de Huechuraba
          </h2>
        </Reveal>

        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-background-200/70 bg-background-50">
            <div className="relative min-h-[300px] lg:min-h-[520px]">
              <img
                src={project.image}
                alt={`Proyecto ${project.name}`}
                title={`${project.name} - Inmobiliaria ADJ`}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <span className="absolute top-6 left-6 rounded-full bg-background-50/90 text-foreground-800 text-xs font-semibold px-4 py-1.5 whitespace-nowrap">
                {project.statusLabel}
              </span>
              <span className="absolute bottom-6 left-6 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-semibold px-4 py-1.5 whitespace-nowrap">
                {project.soldLabel}
              </span>
            </div>

            <div className="flex flex-col gap-6 p-8 md:p-12">
              <div className="flex flex-col gap-2">
                <h3 className="font-heading text-3xl md:text-4xl text-foreground-900">
                  {project.name}
                </h3>
                <p className="text-sm text-foreground-500 flex items-center gap-1.5">
                  <i className="ri-map-pin-line text-primary-500" />
                  {project.address}
                </p>
              </div>

              <p className="text-foreground-600 leading-relaxed">{project.description}</p>

              <div className="grid grid-cols-2 gap-3">
                {project.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-checkbox-circle-fill text-primary-500" />
                    {feature}
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-2 mt-auto">
                {project.gallery.slice(0, 3).map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`${project.name} - galería ${i + 1}`}
                    className="w-20 h-20 object-cover object-top rounded-md"
                  />
                ))}
              </div>

              <Link
                to={`/proyectos/${project.slug}`}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-semibold px-6 py-3 transition-colors duration-300 whitespace-nowrap"
              >
                CONOCER PROYECTO
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}